export default __webpack_public_path__ + "static/030-a936be2a036cf605bad2649c457e98b7.jpg";